import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Divider, Menu } from 'antd';
import { CaretDownOutlined, LogoutOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import { UserContext } from '../contexts';
import SubMenu from 'antd/lib/menu/SubMenu';

export function UserMenu(props: { headerSize: any }) {
  const { user } = useContext(UserContext);

  const [nameInitials, setNameInitials] = useState<string>();

  useEffect(() => {
    if (!user) {
      setNameInitials(undefined);
    } else {
      setNameInitials(user.name.substr(0, 1) + user.surname.substr(0, 1));
    }
  }, [user]);

  if (!user) {
    return null;
  }

  return (
    <Menu theme="dark" mode="horizontal" style={{ backgroundColor: '#294D78', textAlign: 'right' }}>
      <SubMenu
        icon={<Avatar style={{ backgroundColor: '#87d068', marginRight: '0.25rem' }}>{nameInitials}</Avatar>}
        title={
          <span style={{ color: '#ffffffa5' }}>
            {!props.headerSize?.width || props.headerSize?.width >= 1250 ? user?.fullName : null} <CaretDownOutlined />
          </span>
        }
      >
        <Menu.Item key="/help" style={{ marginBottom: 0 }}>
          <NavLink to="/help">
            <QuestionCircleOutlined /> Yardım
          </NavLink>
        </Menu.Item>
        <Divider style={{ margin: 0 }} />
        <Menu.Item key="/logout" style={{ marginBottom: 0 }}>
          <NavLink to="/logout">
            <LogoutOutlined /> Çıkış yap
          </NavLink>
        </Menu.Item>
      </SubMenu>
    </Menu>
  );
}
